import React, { useRef } from "react"

import useTracking from "hooks/useTracking"

import {
  Wrapper,
  WrapperHamburgerLarge,
  WrapperDesktop,
  InnerWrapper,
  ImageWrapper,
  Image,
  TextContainer,
  Name,
  Biography,
  ReadMoreText,
  MoreContainer,
  HeadContainer,
  TextMore,
  Logo,
  Title,
  CheckOutText,
  EditorialDescription,
  LearnMore,
} from "./styles"

const Instructor = ({ author, instructorClass }) => {
  const { name, biography, image, url: authorUrl } = author

  const { id, title, url: classUrl, editorialDescription, editorialTitle } = instructorClass || {}
  const hasSpecialId = id === 138 || id === 139 || id === 152

  const { trackView, trackClick } = useTracking()
  const viewRef = useRef(null)
  const clickRef = useRef(null)

  const trackingId = "Instructor Bio Class"
  const trackingProps = {
    element_id: "Instructor Bio Class",
    product_id: id,
    class_id: id,
    category: "Class Engagement",
    label: "Article|Instructor Bio Class",
  }

  trackView(viewRef, trackingId, trackingProps)
  trackClick(clickRef, trackingId, trackingProps)

  const InnerWrapperComponent = (
    <InnerWrapper hasspecialid={hasSpecialId.toString()}>
      {image && (
        <ImageWrapper>
          <Image
            fetchpriority="high"
            baseUrl={image}
            images={[
              {
                screenSize: 1024,
                transforms: "c_fill,g_auto,w_140,h_140,q_auto,f_auto,fl_lossy",
              },
              {
                screenSize: 768,
                transforms: "c_fill,g_auto,w_100,h_100,q_auto,f_auto,fl_lossy",
              },
              {
                transforms: "c_fill,g_auto,w_100,h_100,q_auto,f_auto,fl_lossy",
              },
            ]}
            alt={name}
          />
        </ImageWrapper>
      )}
      <TextContainer>
        <Name>{name}</Name>
        {biography && <Biography dangerouslySetInnerHTML={{ __html: biography }} />}
        <ReadMoreText href={`/wc/${authorUrl}`}>Read More About {name}</ReadMoreText>
      </TextContainer>
    </InnerWrapper>
  )

  const MoreContainerComponent = (
    <MoreContainer hasspecialid={hasSpecialId.toString()}>
      <HeadContainer>
        <TextMore>More from the author:</TextMore>
        {!hasSpecialId && <Logo />}
      </HeadContainer>
      <a ref={clickRef} href={classUrl} aria-label={title}>
        <Title>{title}</Title>
      </a>
      <CheckOutText>
        {editorialTitle && (
          <p>
            Check out <span>{editorialTitle}</span>
          </p>
        )}
      </CheckOutText>
      <EditorialDescription>{editorialDescription}</EditorialDescription>
      <LearnMore
        to={classUrl}
        hasspecialid={hasSpecialId.toString()}
        aria-label={`Learn More, ${title}`}
      >
        Learn more
      </LearnMore>
    </MoreContainer>
  )
  return (
    <Wrapper ref={viewRef}>
      <WrapperDesktop>
        {InnerWrapperComponent}
        {MoreContainerComponent}
      </WrapperDesktop>
      <WrapperHamburgerLarge>
        {MoreContainerComponent}
        {InnerWrapperComponent}
      </WrapperHamburgerLarge>
    </Wrapper>
  )
}

export default Instructor
